<template>
  <div class="app-container">
    <LoginPage v-if="appStore.loginVisible" />
    <GlobalToolbar v-if="appStore.toolbarVisible" :isMobile="isMobile" />

    <div class="router-container">
      <RouterView class="flex-1 hide-scrollbar-y" />
      <!-- <GlobalTabbar v-if="$route.meta.showTab" /> -->
      <GlobalTabbar v-if="appStore.globalTabbarVisible" />
    </div>
  </div>
</template>

<script setup>
import { getUserDetail } from '@/api'
import { useDevice } from '@/utils/useDevice'
import { clearExpiredPaymentContexts } from '@/utils/paymentCleaner'
import LoginPage from '@/views/login/LoginPage.vue'

const userStore = useUserStore()
const appStore = useAppStore()

const { isMobile } = useDevice()

watch(
  isMobile,
  async (newIsMobile) => {
    let targetCssText = ''

    if (newIsMobile) {
      const module =
        await import('tdesign-mobile-vue/es/style/index.css?inline')
      targetCssText = module.default
      appStore.setToolbarVisible(false)
    } else {
      const module = await import('tdesign-vue-next/es/style/index.css?inline')
      targetCssText = module.default
      appStore.setToolbarVisible(true)
    }

    let styleElement = document.getElementById('tdesign-dynamic-theme')
    if (!styleElement) {
      styleElement = document.createElement('style')
      styleElement.id = 'tdesign-dynamic-theme'
      document.head.appendChild(styleElement)
    }

    if (styleElement.textContent !== targetCssText) {
      styleElement.textContent = targetCssText
      // console.log(`物理层已切换至 ${newIsMobile ? 'Mobile' : 'PC'} 样式`)
    }
  },
  { immediate: true }
)

const onGetUserDetail = async () => {
  const res = await getUserDetail()
  userStore.setUserDetail(res.data)
}

onMounted(async () => {
  clearExpiredPaymentContexts()

  if (window.location.pathname.includes('terms-policy')) {
    return
  }

  const token = localStorage.getItem('token')
  if (token) {
    await onGetUserDetail()
  }
})
</script>

<style lang="scss" scoped>
.app-container {
  height: 100dvh;
  min-width: 375px;
  display: flex;
  @include adapt($prop: flex-direction, $h5: row, $pc: column);
  @include adapt(
    $prop: background,
    // $h5: url('@/assets/images/h5_bg.jpg') no-repeat center/cover,
    // $pc: url('@/assets/images/pc_bg.jpg') no-repeat center/cover
    $h5: #151c2a,
    $pc: #151c2a
  );

  .router-container {
    height: 100%;
    width: 100%;
    display: flex;
    @include adapt($prop: flex-direction, $h5: column, $pc: row-reverse);
    overflow-y: auto;
    @include hide-scrollbar;
  }
}
</style>
